/**
 * Collection editorial blocks — insert pre-rendered cards after Boost product cards.
 */
(function () {
  if (window.__collectionEditorialInit) return;
  window.__collectionEditorialInit = true;

  var configElement = null;
  var cachedConfig = null;
  var cloneCache = Object.create(null);
  var insertSignature = '';
  var lastProductCount = 0;
  var debounceTimer = null;
  var observer = null;
  var observedRoot = null;
  var inserting = false;

  function log() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[collection-editorial]');
    console.log.apply(console, args);
  }

  function getConfig() {
    var el = document.getElementById('collection-editorial-blocks-config');
    if (!el) return null;

    if (el === configElement && cachedConfig) return cachedConfig;

    try {
      cachedConfig = JSON.parse(el.textContent);
      configElement = el;
      cloneCache = Object.create(null);
      insertSignature = '';
      return cachedConfig;
    } catch (e) {
      console.warn('[collection-editorial] config parse error', e);
      return null;
    }
  }

  function parseInsertAfter(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? 0 : n;
  }

  function getPageOffset() {
    var config = getConfig();
    var perPage = (config && config.paginateBy) || 24;
    var page = 1;

    if (typeof Globals !== 'undefined' && Globals.queryParams && Globals.queryParams.page) {
      page = parseInt(Globals.queryParams.page, 10);
    } else if (config && typeof config.pageOffset === 'number' && config.pageOffset >= 0) {
      return config.pageOffset;
    }

    if (isNaN(page) || page < 1) page = 1;
    return (page - 1) * perPage;
  }

  function isProductCard(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.classList.contains('editorial-block') || el.classList.contains('collection-editorial-block')) return false;
    if (el.getAttribute('data-collection-editorial') === 'inserted') return false;

    if (
      el.matches(
        '.grid-product, .boost-sd__product-item, .boost-sd__product-card, [data-product-id], [data-product-grid]'
      )
    ) {
      return true;
    }

    if (el.matches('.grid__item') && el.querySelector('.grid-product, [data-product-id]')) {
      return true;
    }

    return false;
  }

  function getProductCards(root) {
    if (!root) return [];

    var candidates = Array.prototype.slice.call(
      root.querySelectorAll(
        '.grid-product, .boost-sd__product-item, .boost-sd__product-card, [data-product-id], [data-product-grid], .grid__item'
      )
    );

    var products = candidates.filter(function (el) {
      if (!isProductCard(el)) return false;
      if (!root.contains(el)) return false;
      if (el.closest('.editorial-block, .collection-editorial-block')) return false;
      if (el.closest('[data-collection-editorial="inserted"]')) return false;
      return true;
    });

    return products.filter(function (el, i, arr) {
      return !arr.some(function (other) {
        return other !== el && other.contains(el);
      });
    });
  }

  function needsMoreProducts(count, config, offset) {
    var minInsert = null;

    config.blocks.forEach(function (block) {
      var insertAfter = parseInsertAfter(block.insertAfter);
      if (insertAfter > offset) {
        minInsert = minInsert === null ? insertAfter : Math.min(minInsert, insertAfter);
      }
    });

    if (minInsert === null) return false;
    return count < minInsert - offset;
  }

  function getInsertRoot() {
    var filterList = document.querySelector('.boost-sd__filter-product-list');
    var productList = filterList ? filterList.querySelector('.boost-sd__product-list') : null;
    var collectionGrid = document.querySelector('[data-collection-container]');

    if (productList && getProductCards(productList).length) return productList;
    if (filterList && getProductCards(filterList).length) return filterList;
    if (collectionGrid && getProductCards(collectionGrid).length) return collectionGrid;

    return productList || filterList || collectionGrid;
  }

  function getBlocksForPage(config, offset, productCount) {
    return config.blocks
      .filter(function (block) {
        var insertAfter = parseInsertAfter(block.insertAfter);
        return insertAfter > offset && insertAfter <= offset + productCount;
      })
      .sort(function (a, b) {
        return parseInsertAfter(b.insertAfter) - parseInsertAfter(a.insertAfter);
      });
  }

  function fixImageUrl(url) {
    if (!url) return url;
    return url.indexOf('//') === 0 ? 'https:' + url : url;
  }

  function activateEditorialVideos(editorial) {
    if (!editorial) return;

    editorial.querySelectorAll('video.collection-editorial-media__video, video.editorial-block__video').forEach(function (video) {
      var source = video.querySelector('source');
      if (source && source.src && !video.getAttribute('src')) {
        video.src = source.src;
      }

      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('muted', '');

      function tryPlay() {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }

      video.addEventListener('loadeddata', tryPlay, { once: true });
      video.load();
      tryPlay();
    });
  }

  function activateEditorialImages(editorial) {
    if (!editorial) return;

    editorial.querySelectorAll('img.collection-editorial-media__image, img.editorial-block__image').forEach(function (img) {
      img.loading = 'eager';
      img.classList.remove('lazyload', 'lazyloading');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');

      if (img.src) img.src = fixImageUrl(img.src);

      if (img.srcset) {
        img.srcset = img.srcset.replace(/(^|,|\s)\/\//g, function (m, p) {
          return p + 'https://';
        });
      }
    });
  }

  function createEditorialClone(block) {
    var key = String(block.insertAfter);
    var hasVideo = block.html.indexOf('<video') !== -1;

    if (!hasVideo && cloneCache[key]) {
      var cachedClone = cloneCache[key].cloneNode(true);
      activateEditorialImages(cachedClone);
      return cachedClone;
    }

    var template = document.createElement('template');
    template.innerHTML = block.html.trim();
    var node = template.content.firstElementChild;
    if (!node) return null;
    node.setAttribute('data-collection-editorial', 'inserted');
    activateEditorialImages(node);

    if (!hasVideo) {
      cloneCache[key] = node;
    }

    var clone = node.cloneNode(true);
    activateEditorialImages(clone);
    return clone;
  }

  function getProductListCols(root) {
    if (!root) return 3;
    if (root.classList.contains('boost-sd__product-list-grid--2-col')) return 2;
    if (root.classList.contains('boost-sd__product-list-grid--4-col')) return 4;
    return 3;
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function getMobileCols() {
    var cols = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--plp-cols-mobile'),
      10
    );
    return cols > 0 ? cols : 2;
  }

  function isFullWidthEditorial(editorial, desktopCols) {
    var desktopSpan = parseInt(editorial.getAttribute('data-desktop-span'), 10) || 1;
    return (
      editorial.classList.contains('collection-editorial-block--full') || desktopSpan >= desktopCols
    );
  }

  function clearEditorialMediaHeight(editorial) {
    var media = editorial.querySelector('.collection-editorial-media, .editorial-block__media');
    if (!media) return;
    media.style.height = '';
    media.style.aspectRatio = '';
  }

  function measureFlexGap(products) {
    if (products.length < 2) return 0;

    var first = products[0].getBoundingClientRect();
    var second = products[1].getBoundingClientRect();
    return Math.round(second.left - first.right);
  }

  function syncFlexGapFromProducts(root) {
    var products = getProductCards(root);
    var gap = measureFlexGap(products);

    if (gap > 0 && gap < 200) {
      root.style.setProperty('--plp-flex-gap', gap + 'px');
    }
  }

  function getProductMediaHeight(product) {
    if (!product) return 0;

    var selectors = [
      '.boost-sd__product-item-image img',
      '.boost-sd__product-image img',
      '.boost-sd__product-item-image-link img',
      'a[href*="/products/"] img',
      'img',
    ];

    for (var i = 0; i < selectors.length; i++) {
      var img = product.querySelector(selectors[i]);
      if (img && img.offsetHeight > 0) return img.offsetHeight;
    }

    var imageWrap = product.querySelector('[class*="product-item-image"], [class*="product-image"]');
    if (imageWrap && imageWrap.offsetHeight > 0) return imageWrap.offsetHeight;

    return 0;
  }

  function setEditorialFlexWidth(editorial, widthPx) {
    var width = Math.max(0, Math.round(widthPx)) + 'px';
    editorial.style.flex = '0 0 ' + width;
    editorial.style.width = width;
    editorial.style.maxWidth = width;
  }

  function setEditorialFlexCalc(editorial, basisCalc) {
    editorial.style.flex = '0 0 ' + basisCalc;
    editorial.style.width = basisCalc;
    editorial.style.maxWidth = basisCalc;
    editorial.style.minWidth = '0';
    editorial.style.clear = 'none';
  }

  function getFullRowWidthPx(products, gap, cols) {
    if (!products.length) return 0;

    var unitWidth = products[0].offsetWidth;
    if (!unitWidth) return 0;

    return unitWidth * cols + gap * (cols - 1);
  }

  function syncEditorialMediaHeight(editorial, product) {
    var media = editorial.querySelector('.collection-editorial-media, .editorial-block__media');
    if (!media || !product) return;

    var mediaHeight = getProductMediaHeight(product);
    if (!mediaHeight) return;

    media.style.aspectRatio = 'auto';
    media.style.height = mediaHeight + 'px';
  }

  function syncEditorialLayoutFromProduct(editorial, product, mobile) {
    if (!editorial || !product) return;

    editorial.style.display = 'flex';
    editorial.style.flexDirection = 'column';
    editorial.style.alignSelf = 'flex-start';
    editorial.style.clear = 'none';
    editorial.style.float = 'none';

    if (mobile) {
      editorial.style.margin = '0';
      editorial.style.padding = '0';
      return;
    }

    var productStyle = window.getComputedStyle(product);
    editorial.style.marginTop = productStyle.marginTop;
    editorial.style.marginRight = productStyle.marginRight;
    editorial.style.marginBottom = productStyle.marginBottom;
    editorial.style.marginLeft = productStyle.marginLeft;
    editorial.style.paddingTop = productStyle.paddingTop;
    editorial.style.paddingRight = productStyle.paddingRight;
    editorial.style.paddingBottom = productStyle.paddingBottom;
    editorial.style.paddingLeft = productStyle.paddingLeft;
  }

  function applyEditorialSizing(root, products, offset) {
    var gap = measureFlexGap(products);
    var desktopCols = getProductListCols(root);
    var mobileCols = getMobileCols();
    var mobile = isMobileViewport();
    var contentWidth =
      (document.querySelector('.boost-sd__filter-product-list') || root).offsetWidth || root.offsetWidth;
    var fullRowWidth = getFullRowWidthPx(products, gap, mobile ? mobileCols : desktopCols);

    root
      .querySelectorAll(
        '.collection-editorial-block[data-collection-editorial="inserted"], .editorial-block[data-collection-editorial="inserted"]'
      )
      .forEach(function (editorial) {
        var insertAfter = parseInsertAfter(editorial.getAttribute('data-insert-after'));
        var productIndex = insertAfter - offset - 1;
        var desktopSpan = parseInt(editorial.getAttribute('data-desktop-span'), 10) || 1;
        var mobileSpan = parseInt(editorial.getAttribute('data-mobile-span'), 10) || 1;
        var referenceProduct = products[productIndex] || products[products.length - 1];
        var isFull = isFullWidthEditorial(editorial, desktopCols);

        if (!referenceProduct) return;

        syncEditorialLayoutFromProduct(editorial, referenceProduct, mobile);

        if (mobile) {
          if (isFull) {
            setEditorialFlexCalc(editorial, '100%');
            clearEditorialMediaHeight(editorial);
          } else {
            var span = Math.min(mobileSpan, mobileCols);
            if (span >= mobileCols) {
              setEditorialFlexCalc(editorial, '100%');
            } else {
              var gapShare = (gap * (mobileCols - span)) / mobileCols;
              setEditorialFlexCalc(
                editorial,
                'calc(' + (span * 100) / mobileCols + '% - ' + gapShare + 'px)'
              );
            }
            syncEditorialMediaHeight(editorial, referenceProduct);
          }
        } else if (isFull) {
          var rowWidth = fullRowWidth || contentWidth;
          setEditorialFlexWidth(editorial, Math.min(rowWidth, contentWidth));
          clearEditorialMediaHeight(editorial);
        } else {
          var unitWidthDesktop = referenceProduct.offsetWidth;
          setEditorialFlexWidth(editorial, unitWidthDesktop * desktopSpan + gap * (desktopSpan - 1));
          syncEditorialMediaHeight(editorial, referenceProduct);
        }
      });
  }

  function removeInsertedEditorials(root) {
    root.querySelectorAll('.collection-editorial-block[data-collection-editorial="inserted"], .editorial-block[data-collection-editorial="inserted"]').forEach(function (el) {
      el.remove();
    });
  }

  function isBoostReady() {
    if (typeof window.boostWidgetIntegration === 'undefined' || !window.boostWidgetIntegration) {
      return false;
    }
    return window.boostWidgetIntegration.status !== 'initializing';
  }

  function waitForBoostReady(callback, attempt) {
    attempt = attempt || 0;
    if (isBoostReady() || attempt > 100) {
      callback();
      return;
    }
    setTimeout(function () {
      waitForBoostReady(callback, attempt + 1);
    }, 100);
  }

  function waitForStableProducts(callback, attempt, lastCount, stableTicks) {
    attempt = attempt || 0;
    stableTicks = stableTicks || 0;
    lastCount = typeof lastCount === 'number' ? lastCount : -1;

    if (!isBoostReady()) {
      if (attempt > 100) {
        callback();
        return;
      }
      setTimeout(function () {
        waitForStableProducts(callback, attempt + 1, lastCount, 0);
      }, 100);
      return;
    }

    var config = getConfig();
    var root = getInsertRoot();
    var offset = getPageOffset();
    var count = root ? getProductCards(root).length : 0;
    var stillLoading = config && needsMoreProducts(count, config, offset);

    if (count === lastCount && count > 0 && !stillLoading) {
      stableTicks += 1;
    } else {
      stableTicks = 0;
      lastCount = count;
    }

    if ((stableTicks >= 2 && !stillLoading) || attempt > 100) {
      callback();
      return;
    }

    setTimeout(function () {
      waitForStableProducts(callback, attempt + 1, lastCount, stableTicks);
    }, 150);
  }

  function insertEditorials() {
    if (inserting) return;

    var config = getConfig();
    if (!config || !config.blocks || !config.blocks.length) return;

    if (!isBoostReady()) return;

    var root = getInsertRoot();
    if (!root) {
      log('no insert root found');
      return;
    }

    var products = getProductCards(root);
    if (!products.length) {
      log('no product cards yet', {
        boostChildren: document.querySelector('.boost-sd__filter-product-list')
          ? document.querySelector('.boost-sd__filter-product-list').children.length
          : 0,
        gridChildren: document.querySelector('[data-collection-container]')
          ? document.querySelector('[data-collection-container]').children.length
          : 0,
      });
      return;
    }

    if (products.length !== lastProductCount) {
      lastProductCount = products.length;
      insertSignature = '';
    }

    var offset = getPageOffset();
    var blocks = getBlocksForPage(config, offset, products.length);

    if (needsMoreProducts(products.length, config, offset)) {
      log('waiting for more products', {
        count: products.length,
        offset: offset,
        blocksInConfig: config.blocks.map(function (b) { return b.insertAfter; }),
      });
      scheduleInsert();
      return;
    }

    var signature =
      offset + ':' + products.length + ':' + blocks.map(function (b) { return b.insertAfter; }).join(',');

    var existing = root.querySelectorAll('.collection-editorial-block[data-collection-editorial="inserted"], .editorial-block[data-collection-editorial="inserted"]');
    if (signature === insertSignature && existing.length === blocks.length) {
      return;
    }

    inserting = true;

    try {
      removeInsertedEditorials(root);
      products = getProductCards(root);

      var positions = [];
      var successCount = 0;

      blocks.forEach(function (block) {
        var insertAfter = parseInsertAfter(block.insertAfter);
        var localIndex = insertAfter - offset;
        var productIndex = localIndex - 1;

        if (productIndex < 0 || productIndex >= products.length) return;

        var product = products[productIndex];
        var editorial = createEditorialClone(block);
        if (!editorial) return;

        var next = product.nextElementSibling;
        if (
          next &&
          next.getAttribute('data-collection-editorial') === 'inserted' &&
          parseInsertAfter(next.getAttribute('data-insert-after')) === insertAfter
        ) {
          return;
        }

        product.insertAdjacentElement('afterend', editorial);
        activateEditorialVideos(editorial);
        positions.push(insertAfter);
        successCount += 1;
      });

      insertSignature = signature;
      syncFlexGapFromProducts(root);
      products = getProductCards(root);
      applyEditorialSizing(root, products, offset);

      log('product count:', products.length);
      log('editorial count:', blocks.length);
      log('insertion positions:', positions);
      log('successful insertions:', successCount);
      log('insert root:', root.className || root.getAttribute('data-collection-container'));

      if (window.lazySizes && window.lazySizes.loader) {
        window.lazySizes.loader.checkElems();
      }

      if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
        window.theme.reinitProductGridItem();
      }
    } finally {
      inserting = false;
    }
  }

  function scheduleInsert() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      waitForStableProducts(insertEditorials);
    }, 150);
  }

  function startObserver() {
    var root = getInsertRoot();
    if (!root) return;

    if (observer && observedRoot === root) return;

    if (observer) observer.disconnect();

    observedRoot = root;
    observer = new MutationObserver(function () {
      if (inserting) return;
      scheduleInsert();
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  function run() {
    waitForBoostReady(function () {
      waitForStableProducts(function () {
        insertEditorials();
        startObserver();
      });
    });
  }

  function init(attempt) {
    attempt = attempt || 0;

    if (!getConfig()) {
      if (attempt < 50) {
        setTimeout(function () {
          init(attempt + 1);
        }, 100);
      }
      return;
    }

    document.body.classList.add('collection-editorial-plp');
    var plp = document.querySelector('.collection-editorial-plp');
    if (plp) {
      plp.classList.add('collection-editorial-plp--active');
      if (getMobileCols() === 1) {
        plp.classList.add('collection-editorial-plp--mobile-1-col');
      }
    }

    function refreshAfterViewportChange() {
      insertSignature = '';
      if (plp) {
        plp.classList.toggle(
          'collection-editorial-plp--mobile-1-col',
          isMobileViewport() && getMobileCols() === 1
        );
      }

      waitForBoostReady(function () {
        setTimeout(function () {
          scheduleInsert();
        }, 200);
      });
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        resizeTimer = null;
        refreshAfterViewportChange();
      }, 200);
    });

    var mobileMq = window.matchMedia('(max-width: 768px)');
    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', refreshAfterViewportChange);
    } else if (mobileMq.addListener) {
      mobileMq.addListener(refreshAfterViewportChange);
    }

    log('init', { blocks: cachedConfig.blocks.length, paginateBy: cachedConfig.paginateBy });
    run();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }
})();
